<template>
  <!-- 編輯某課程的紀錄 -->
  <div class="page">
    <f7-navbar title="新增紀錄" back-link="Back">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="page-content"> <!-- datepicker 開啟的時候，要在 page-content 加上 style="overflow: hidden;" -->
      <header class="wave-header sticky-top"></header>
      <ul class="upload-record-img-wrap">
        <!-- 已上傳 
      <li
        class="basic-img-ratio"
        style="background-image: url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTs_acuUzZqD_Ap4cDEnFU6_vKooZtxQj8UqQ91UFTMqHT4t3pp)">
        <button class="delete-fixed">
          <i class="material-icons">clear</i>
        </button>
      </li>
        -->
        <li class="basic-img-ratio image-cover" v-bind:style="{'background-image':'url('+localClassImagePath+')'}">
          <form>
            <input type="file" id="uploadImg" value="" @change="fileChange" accept="image/gif,image/jpeg,image/jpg,image/png"/>
              <label for="uploadImg" class="upload-label" id="imageSrcLabel">
                <i id="imageSrcIcon" class="material-icons">add</i>
                <span id="imageSrcSpan">上傳照片</span>
              </label>
              <template v-if="isloadingImageFlag">
                <div class="uploading-bar"></div>
              </template>
          </form>
        </li>
      </ul>

      <div class="list no-hairlines-md">
        <ul>
          <li class="item-content item-input">
            <div class="item-media">
              <i class="f7-icons">calendar</i>
            </div>
            <!-- 輔導日期 -->
            <div class="item-inner">
              <div class="item-title item-label">輔導日期</div>
              <div class="item-input-wrap">
                <date-picker
                  v-model="time1"
                  valuetype="format"
                  :first-day-of-week="1"
                  placeholder="請輸入日期"
                  confirm-text="確定"
                  confirm
                ></date-picker>
              </div>
            </div>
          </li>

          <li class="item-content item-input">
            <div class="item-media">
              <i class="f7-icons">time</i>
            </div>
            <!-- 起始時間 -->
            <div class="item-inner">
              <div class="item-title item-label">起始時間</div>
              <div class="item-input-wrap">
                
                <date-picker class="time-picker"
                  v-model="value1"
                  type="time"
                  format="HH:mm"
                  :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                  placeholder="請輸入時間"
                  confirm-text="確定"
                  confirm
                ></date-picker>
              </div>
            </div>
            <!-- 輔導時數 -->
            <div class="item-inner">
              <div class="item-title item-label">輔導時數</div>
              <div class="item-input-wrap">
                <select name="時數" v-model="selected">
                  <option value="1" selected>1 小時</option>
                  <option value="2">2 小時</option>
                  <option value="3">3 小時</option>
                  <option value="4">4 小時</option>
                  <option value="5">5 小時</option>
                  <option value="6">6 小時</option>
                </select>
              </div>
            </div>
          </li>

          <li class="item-content item-input">
            <div class="item-media">
              <i class="f7-icons">document_text</i>
            </div>
            <!-- 內容概述 -->
            <div class="item-inner">
              <div class="item-title item-label">內容概述</div>
              <div class="item-input-wrap">
                <textarea class="resizable" placeholder="請輸入簡要的上課內容" v-model="note"></textarea>
              </div>
            </div>
          </li>
        </ul>
        <a class="button button-large" @click="uploadAddCoachClassRecord">送出</a>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "../../../service";
import DatePicker from "vue2-datepicker";

import PopModalTest from "../counseling-apply/PopModalTest";
import axios from '../../../js/axiosModule.js';
import { bus } from '../../../js/bus';
var moment = require('moment');
var FormData = require('form-data');

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      formData: new FormData(),
      dish: Service.getDish(this.$f7route.params.id),
      time1:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate(),
      value1: "", //選擇時間
      file:null,
      selected: "",
      note:"",
      classImagePath :"",
      localClassImagePath:"",
      isloadingImageFlag:false
    };
  },
  methods: {
    fileChange :function(e) {
      
      let self = this;
      self.isloadingImageFlag = true;
      self.file = e.target.files[0];
      this.formData = new FormData();
      this.formData.append("file", self.file);
      self.upload();
    },
    upload:function() {
      let self = this;

      if (self.formData.get("file") != null && self.formData.get("file") != undefined) {
        let config = {
          header : {
            'Content-Type' : 'multipart/form-data'
          }
             
        }

        axios.axiosTokenPost(self.$app.axiosUrl+"/api/File/UploadFile",self.formData,config).then((response)=> {
          self.localClassImagePath = self.$app.cdnUrl +'/'+ response.data.data;
          self.classImagePath = response.data.data;
          document.getElementById("imageSrcSpan").innerHTML = "";
          document.getElementById("imageSrcIcon").style.display = "none";
          self.isloadingImageFlag=false;
          //self.uploadAddCoachClassRecord();
        }).catch(err=>function() {
          if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
            self.$f7router.navigate("/login");
          } 
        });
      } else {
        alert("請選擇圖片！");
      }
      
    },
    uploadAddCoachClassRecord : function() {
      let self = this;
      if (self.value1 !== undefined && self.value1 !=='' &&
        self.selected !== undefined &&  self.selected !=='' &&
        self.classImagePath !== undefined &&  self.classImagePath !=='' &&
        self.note !== undefined && self.note !=='') {
          
          var params = {};
          params.id = 0;
          params.courseId = window.localStorage.getItem("courseCodeStr");
          params.classAt = self.value1;
          params.classHours = self.selected;
          params.allowHours = 0;
          params.classImagePath = self.classImagePath;
          params.feedbackScore=0;
          params.feedbackNote = "";   //should be modify
          params.status = 10;
          params.createdBy = self.$store.state.userInfo.studentNo;
          params.createdAt = self.getNowTime();
          params.updatedBy = self.$store.state.userInfo.studentNo;
          params.updatedAt = self.getNowTime();

         // console.log(self.classImagePath);
          axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/AddCoachClassRecord",params).then((response) => {
          // console.dir(response);
            self.$dialog.modal({
              component: PopModalTest,
              title: "",
              //showCloseBtn: this.checked,
              params: { firstInput: "" },

              callback: p => {
                //self.$dialog.alert("已送出", { type: "success", showIcon: false });
           //   console.log("infor");
              }
            });
          // self.$f7router.navigate("/coursework");
            
          }).catch(err=>function() {
            if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
              self.$f7router.navigate("/login");
            } 
          });


      } else {
        alert("欄位不可空白·謝謝拉！");
      }
      
    },
     getNowTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss")._d;
      return dateTime;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/counseling/record-edit.vue